import React, { Component, PropTypes } from 'react'
import { Field } from 'redux-form'
import { Link } from 'react-router'

import './Payment.scss'
import generatePaymentTokens from '@src/services/payment'
import MobileNavBar from 'components/MobileNavBar'
import InputControl from 'components/InputControl'
import Backdrop from 'components/Backdrop'
import Loader from 'components/Loader'
import * as paths from 'utils/paths'

import { LogOnMount } from "@amplitude/react-amplitude";

class Payment extends Component {
  constructor (props) {
    super(props)

    this.handleSubmit = this.handleSubmit.bind(this)
  }

  handleSubmit (card) {
    const {
      updateService,
      createService,
      displayError
    } = this.props

    return generatePaymentTokens(card).then((tokens) => {
      const error = Object.keys(tokens).every((token) => {
        return tokens[token].error
      })

      if (error) {
        return Promise.reject(tokens.conekta.error.message)
      }

      tokens = Object.keys(tokens).reduce((acc, token) => {
        if (tokens[token].error) {
          return acc
        }

        acc[`${token}_temporary_token`] = tokens[token]
        return acc
      }, {})

      updateService({ paymentTokens: tokens })
      createService()
    }).catch((error) => {
      displayError(error)
    })
  }

  render () {
    const {
      handleSubmit,
      creatingService,
      goBack,
      aliada,
      service
    } = this.props

    const price = service.promoCode.valid
                  ? service.promoCode.discountedPrice
                  : aliada.serviceCost

    const userProfileUrl = paths.currentUserProfile()

    return (
      <div className='Payment navbar-screen'>
        <LogOnMount eventType="payment-form-screen" />

        <MobileNavBar
          leftControl={
            <Link onClick={goBack}>
              <span className='icon-arrow-back' />
            </Link>
          }
          rightControl={
            <Link className='btn btn-default' to={userProfileUrl}>
              Mi perfil
            </Link>
          }
        >
          Método de Pago
        </MobileNavBar>

        <div className='Payment-content navbar-screen-content'>
          <div className='navbar-screen-container'>
            <form onSubmit={handleSubmit(this.handleSubmit)}>

              <div className='Payment-fields'>
                <Field
                  name='number'
                  component={InputControl}
                  icon='card'
                  label='Número de tarjeta de crédito' />

                <div className='Payment-numberFields'>
                  <Field
                    name='exp_month'
                    component={InputControl}
                    label='Mes (MM)' />

                  <Field
                    name='exp_year'
                    component={InputControl}
                    label='Año (YY)' />

                  <Field
                    name='cvc'
                    component={InputControl}
                    label='CVC' />
                </div>

                <Field
                  name='name'
                  icon='user'
                  component={InputControl}
                  label='Nombre del titular' />
              </div>

              <div className='Payment-safetyLegend'>
                <span className='icon-password' />
                <p>Procesamos tus
                pagos en tiempo real con todas las certificaciones de seguridad requeridas por
                el Banco de México y la CNBV.</p>
              </div>

              <div className='Payment-payButton'>
                <button
                  className='btn btn-primary btn-block btn-lg'
                  type='submit'
                  disabled={creatingService}
                  >
                  Pagar ${price}
                </button>
              </div>
            </form>
          </div>
        </div>

        {
          creatingService &&
          (<Backdrop>
            <Loader text='Procesando pago' className='Payment-loader' />
          </Backdrop>)
        }
      </div>
    )
  }
}
Payment.displayName = 'Payment'
Payment.propTypes = {
  updateService: PropTypes.func.isRequired,
  createService: PropTypes.func.isRequired,
  goBack: PropTypes.func.isRequired,
  aliada: PropTypes.shape({
    serviceCost: PropTypes.number.isRequired
  }).isRequired,
  service: PropTypes.shape({
    promoCode: PropTypes.shape({
      valid: PropTypes.bool,
      discountedPrice: PropTypes.number
    }).isRequired
  }).isRequired
}

export default Payment



// WEBPACK FOOTER //
// ./src/screens/App/screens/Booking/screens/Payment/Payment.js